var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeTopRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 483,
  height: 467,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeOpacity: 0.2,
  strokeWidth: 2.099,
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__a)",
  d: "M442.709 100.593c10.638 2.066 19.054 8.395 22.076 16.602l53.68 145.769c3.023 8.206.192 17.046-7.425 23.188L375.758 395.234c-7.616 6.142-18.863 8.653-29.503 6.588l-188.961-36.686c-10.639-2.066-19.055-8.394-22.077-16.602l-53.68-145.768c-3.022-8.207-.192-17.047 7.425-23.188L224.244 70.495c7.617-6.142 18.864-8.653 29.503-6.588z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__b)",
  d: "M430.478 102.98c10.238 1.695 18.537 7.513 21.771 15.265l57.444 137.665c3.235 7.751.913 16.257-6.09 22.313l-124.388 107.57c-7.003 6.057-17.624 8.744-27.862 7.05l-181.832-30.095c-10.238-1.695-18.537-7.514-21.771-15.265L90.305 209.817c-3.235-7.75-.912-16.257 6.091-22.313l124.387-107.57c7.004-6.056 17.625-8.744 27.863-7.05z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__c)",
  d: "M418.645 105.864c9.816 1.348 17.964 6.672 21.373 13.966l60.552 129.543c3.41 7.293 1.562 15.45-4.845 21.396l-113.8 105.604c-6.407 5.946-16.402 8.779-26.219 7.431l-174.353-23.939c-9.816-1.348-17.963-6.671-21.372-13.966L99.429 216.356c-3.41-7.293-1.563-15.45 4.844-21.395L218.074 89.356c6.407-5.945 16.402-8.778 26.219-7.43z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__d)",
  d: "M407.236 109.224c9.377 1.026 17.339 5.87 20.887 12.707l63.005 121.428c3.548 6.837 2.141 14.628-3.689 20.439L383.891 366.999c-5.83 5.81-15.198 8.758-24.576 7.732l-166.553-18.227c-9.378-1.027-17.34-5.871-20.887-12.708L108.87 222.368c-3.548-6.836-2.141-14.628 3.688-20.438L216.106 98.729c5.83-5.81 15.199-8.758 24.577-7.732z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__e)",
  d: "M396.282 113.043c8.922.731 16.666 5.112 20.315 11.494l64.809 113.345c3.649 6.381 2.648 13.794-2.625 19.445l-93.656 100.376c-5.273 5.651-14.018 8.683-22.941 7.954l-158.465-12.97c-8.921-.73-16.666-5.111-20.314-11.493l-64.809-113.345c-3.649-6.382-2.649-13.795 2.624-19.446l93.657-100.376c5.273-5.651 14.018-8.683 22.94-7.953z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__f)",
  d: "M385.805 117.297c8.452.46 15.947 4.397 19.661 10.327l65.969 105.319c3.715 5.93 3.084 12.952-1.654 18.422l-84.15 97.145c-4.738 5.47-12.864 8.556-21.317 8.096l-150.119-8.174c-8.452-.461-15.947-4.397-19.661-10.327l-65.968-105.32c-3.715-5.929-3.084-12.952 1.654-18.421l84.15-97.146c4.738-5.469 12.864-8.555 21.316-8.095z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__g)",
  d: "M375.832 121.966c7.969.217 15.185 3.728 18.929 9.211l66.493 97.376c3.744 5.482 3.447 12.104-.779 17.37l-75.054 93.527c-4.226 5.266-11.739 8.377-19.709 8.16l-141.547-3.849c-7.969-.217-15.185-3.728-18.929-9.211l-66.493-97.376c-3.744-5.482-3.447-12.104.779-17.37l75.054-93.527c4.226-5.266 11.739-8.377 19.709-8.16z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__h)",
  d: "M366.391 127.029c7.475.001 14.384 3.106 18.121 8.148l66.391 89.541c3.739 5.041 3.738 11.252.001 16.294l-66.391 89.54c-3.738 5.042-10.647 8.148-18.123 8.148H233.609c-7.476-.001-14.384-3.106-18.122-8.148l-66.391-89.541c-3.739-5.041-3.738-11.252 0-16.294l66.39-89.54c3.738-5.042 10.647-8.148 18.123-8.148z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__i)",
  d: "M357.499 132.46c6.974-.189 13.547 2.533 17.245 7.141l65.672 81.836c3.698 4.608 3.958 10.402.682 15.199l-58.181 85.204c-3.276 4.797-9.59 7.87-16.563 8.06L242.5 333.267c-6.974.189-13.547-2.532-17.245-7.14l-65.672-81.837c-3.698-4.607-3.958-10.401-.682-15.198l58.181-85.205c3.276-4.797 9.59-7.869 16.563-8.059z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__j)",
  d: "M349.181 138.239c6.463-.352 12.677 2.008 16.3 6.191l64.35 74.288c3.623 4.182 4.106 9.552 1.265 14.087l-50.446 80.538c-2.84 4.534-8.572 7.545-15.036 7.897l-114.797 6.251c-6.463.351-12.677-2.009-16.3-6.192l-64.35-74.287c-3.624-4.182-4.106-9.553-1.266-14.087l50.447-80.539c2.84-4.534 8.572-7.545 15.036-7.897z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__k)",
  d: "M341.455 144.336c5.948-.487 11.778 1.535 15.293 5.302l62.438 66.918c3.515 3.767 4.182 8.709 1.75 12.963l-43.206 75.564c-2.432 4.254-7.595 7.175-13.544 7.662l-105.643 8.646c-5.948.486-11.778-1.535-15.293-5.303l-62.438-66.917c-3.515-3.767-4.182-8.709-1.75-12.964l43.206-75.563c2.432-4.254 7.595-7.175 13.544-7.662z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__l)",
  d: "M334.34 150.732c5.429-.594 10.853 1.113 14.228 4.477l59.949 59.748c3.375 3.364 4.189 7.875 2.136 11.833l-36.477 70.3c-2.053 3.958-6.663 6.763-12.093 7.357l-96.425 10.552c-5.429.594-10.853-1.112-14.228-4.477l-59.949-59.748c-3.376-3.363-4.19-7.874-2.136-11.832l36.477-70.301c2.053-3.958 6.663-6.762 12.092-7.357z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__m)",
  d: "M327.852 157.395c4.908-.673 9.906.743 13.109 3.716l56.901 52.803c3.203 2.972 4.127 7.05 2.422 10.697l-30.276 64.772c-1.704 3.646-5.778 6.308-10.687 6.983l-87.176 11.969c-4.908.673-9.905-.743-13.109-3.716l-56.9-52.802c-3.204-2.973-4.127-7.051-2.423-10.698l30.276-64.772c1.705-3.646 5.779-6.308 10.687-6.982z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__n)",
  d: "M322.007 164.301c4.387-.726 8.939.426 11.941 3.022l53.309 46.101c3.001 2.596 3.996 6.241 2.61 9.563l-24.619 58.999c-1.386 3.322-4.943 5.816-9.331 6.542l-77.928 12.898c-4.387.726-8.939-.425-11.94-3.021l-53.309-46.102c-3.002-2.595-3.997-6.241-2.611-9.562l24.619-59c1.386-3.322 4.943-5.816 9.331-6.542z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__o)",
  d: "M316.821 171.425c3.869-.751 7.959.162 10.728 2.396l49.194 39.666c2.77 2.233 3.799 5.448 2.7 8.432l-19.52 53.007c-1.099 2.984-4.159 5.286-8.028 6.037l-68.713 13.34c-3.869.751-7.959-.162-10.728-2.396l-49.194-39.666c-2.77-2.233-3.799-5.448-2.7-8.432l19.52-53.007c1.099-2.984 4.159-5.286 8.028-6.037z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__p)",
  d: "M312.297 178.737c3.354-.749 6.966-.048 9.475 1.84l44.574 33.517c2.51 1.887 3.536 4.673 2.692 7.309l-14.991 46.817c-.844 2.636-3.43 4.721-6.784 5.47l-59.564 13.299c-3.354.749-6.966.048-9.475-1.84l-44.574-33.517c-2.51-1.887-3.536-4.673-2.692-7.309l14.991-46.817c.844-2.636 3.43-4.721 6.784-5.47z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__q)",
  d: "M308.456 186.213c2.844-.72 5.965-.203 8.187 1.355l39.471 27.673c2.222 1.558 3.208 3.921 2.586 6.199l-11.042 40.453c-.622 2.278-2.757 4.124-5.601 4.844l-50.513 12.78c-2.844.719-5.966.203-8.188-1.355l-39.47-27.674c-2.223-1.558-3.209-3.921-2.587-6.198l11.043-40.454c.622-2.277 2.757-4.124 5.601-4.843z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__r)",
  d: "M305.302 193.819c2.342-.663 4.96-.304 6.869.944l33.906 22.153c1.909 1.247 2.818 3.193 2.386 5.104l-7.686 33.94c-.433 1.911-2.142 3.497-4.484 4.161l-41.591 11.788c-2.342.663-4.96.303-6.869-.944l-33.906-22.153c-1.909-1.247-2.818-3.193-2.386-5.104l7.686-33.941c.433-1.91 2.142-3.497 4.484-4.16z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__s)",
  d: "M302.838 201.533c1.848-.582 3.955-.351 5.526.605l27.902 16.974c1.571.956 2.368 2.492 2.09 4.029l-4.928 27.303c-.277 1.537-1.587 2.843-3.435 3.424l-32.83 10.329c-1.849.581-3.955.351-5.526-.605l-27.903-16.975c-1.571-.955-2.367-2.491-2.09-4.028l4.928-27.304c.277-1.537 1.587-2.842 3.435-3.424z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__t)",
  d: "M301.073 209.32c1.366-.473 2.952-.343 4.162.341l21.484 12.154c1.21.685 1.859 1.82 1.703 2.978l-2.776 20.565c-.156 1.158-1.094 2.163-2.46 2.636l-24.261 8.411c-1.365.474-2.952.344-4.162-.341l-21.484-12.154c-1.21-.685-1.859-1.819-1.703-2.977l2.776-20.566c.157-1.157 1.094-2.163 2.46-2.636z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__u)",
  d: "M300.01 217.159c.896-.34 1.957-.283 2.783.151l14.678 7.709c.826.434 1.293 1.179 1.223 1.953l-1.235 13.752c-.069.774-.664 1.461-1.56 1.801l-15.913 6.044c-.896.34-1.957.282-2.783-.152l-14.677-7.709c-.827-.434-1.293-1.178-1.223-1.953l1.234-13.752c.07-.774.665-1.461 1.561-1.801z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeTopRight_svg__v)",
  d: "M299.655 225.016c.44-.182.971-.167 1.394.038l7.507 3.653c.423.205.672.571.655.959l-.309 6.889c-.017.387-.299.739-.739.921l-7.816 3.236c-.44.182-.972.168-1.394-.038l-7.507-3.653c-.423-.205-.673-.571-.655-.959l.309-6.888c.017-.388.299-.74.739-.922z",
  opacity: 0.73
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__a",
  x1: 14653,
  x2: -8790.91,
  y1: 10781.6,
  y2: 41959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__b",
  x1: 14443.6,
  x2: -6753.71,
  y1: 9923.66,
  y2: 40157.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__c",
  x1: 14175.5,
  x2: -4902.49,
  y1: 9090.52,
  y2: 38289.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__d",
  x1: 13850.8,
  x2: -3234.2,
  y1: 8284.3,
  y2: 36367.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__e",
  x1: 13471.7,
  x2: -1745.05,
  y1: 7507.03,
  y2: 34404.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__f",
  x1: 13040.3,
  x2: -430.723,
  y1: 6760.67,
  y2: 32409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__g",
  x1: 12558.9,
  x2: 713.583,
  y1: 6047.08,
  y2: 30391.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__h",
  x1: 12030,
  x2: 1693.01,
  y1: 5368.06,
  y2: 28361.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__i",
  x1: 11456.2,
  x2: 2512.92,
  y1: 4725.28,
  y2: 26325.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__j",
  x1: 10839.9,
  x2: 3178.89,
  y1: 4120.34,
  y2: 24292.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__k",
  x1: 10184.1,
  x2: 3696.53,
  y1: 3554.72,
  y2: 22267.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__l",
  x1: 9491.36,
  x2: 4071.52,
  y1: 3029.83,
  y2: 20257.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__m",
  x1: 8764.66,
  x2: 4309.48,
  y1: 2546.94,
  y2: 18266.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__n",
  x1: 8006.89,
  x2: 4415.99,
  y1: 2107.24,
  y2: 16300.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__o",
  x1: 7221.08,
  x2: 4396.49,
  y1: 1711.79,
  y2: 14362.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__p",
  x1: 6410.25,
  x2: 4256.3,
  y1: 1361.57,
  y2: 12456.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__q",
  x1: 5577.53,
  x2: 4000.56,
  y1: 1057.41,
  y2: 10585.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__r",
  x1: 4726.06,
  x2: 3634.2,
  y1: 800.051,
  y2: 8752.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__s",
  x1: 3859.03,
  x2: 3161.95,
  y1: 590.116,
  y2: 6959.87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__t",
  x1: 2979.65,
  x2: 2588.3,
  y1: 428.1,
  y2: 5209.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__u",
  x1: 2091.18,
  x2: 1917.48,
  y1: 314.396,
  y2: 3504.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeTopRight_svg__v",
  x1: 1196.87,
  x2: 1153.48,
  y1: 249.268,
  y2: 1844.89,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})))));
export default SvgShapeTopRight;